const backendUrl =
  process.env.REACT_APP_OIAJ_BACKEND_URL || "https://juez.oia.unsam.edu.ar/api";
const basename = process.env.REACT_APP_OIAJ_BASENAME || undefined;

export { backendUrl, basename };
